import React from "react";

const WorkflowCard = ({ icon: Icon, heading, copy }) => (
  <article className="workflow-card">
    <div className="workflow-card__icon" aria-hidden="true">
      <Icon fontSize="inherit" />
    </div>
    <div className="workflow-card__body">
      <h3 className="workflow-card__heading">{heading}</h3>
      <p className="workflow-card__copy">{copy}</p>
    </div>
  </article>
);

export default WorkflowCard;
